// extracted by mini-css-extract-plugin
export default {"wrapper":"DotDotDotMenu_wrapper__I542I"};